import { ComponentMeta, Story as GenericStory } from "@storybook/react";
import React from "react";
import { CircleIcon } from "lucide-react";
import CardSelect from "./CardSelect";
import Flex from "../Flex";

type Story = GenericStory<React.ComponentProps<typeof CardSelect>>;

const commonArgs: React.ComponentProps<typeof CardSelect> = {
    title: "Processing button title",
    icon: <CircleIcon />,
    trackName: "Storybook.Processing.CardSelect.Clicked"
};

export default {
    title: "common/CardSelect",
    component: CardSelect,
    args: commonArgs
} as ComponentMeta<typeof CardSelect>;

const Template: Story = args => {
    return (
        <Flex column maxWidth="300px">
            <CardSelect {...args} />
        </Flex>
    );
};

export const Default = Template.bind({});

export const IsActive = Template.bind({});
IsActive.args = {
    active: true
};

export const IsDisabled = Template.bind({});
IsDisabled.args = {
    disabled: true
};

export const WithSubtitle = Template.bind({});
WithSubtitle.args = {
    subtitle: "Subtitle text"
};
